import { styled, Toolbar } from "@mui/material";

export const ToolbarContainer = styled(Toolbar)({
    height: "100%",
    width: "100%",
    padding: "0 !important",
    alignSelf: "center",
    marginTop: "16px",
    "&.MuiToolbar-root": {
        margin: "0",
        minHeight: "unset",
    },
});
